import { toast } from "react-toastify";
import UserClient from "../../../api/user";
import TransporterClient from "../../../api/transporter";
import { handleToastError } from "../../../utils/toastHandler";

toast.configure();
export const users = {
  state: {
    users: [],
    selectedUser: {},
    newUser: {
      id: "",
      email: "",
      name: "",
      type: {},
      userSubType: "",
      driverLicense: "",
      driverLicenseExpiration: "",
      tollNumber: "",
    },
    managerId: "",
    permission: {
      selectedId: [],
      relatedAddresses: [],
      error: false,
    },
    formErrors: {},
    loading: false,
  },
  reducers: {
    setUsers(state, payload) {
      return {
        ...state,
        users: payload,
      };
    },
    setNewUser(state, payload) {
      const { key, value } = payload;
      return {
        ...state,
        newUser: {
          ...state.newUser,
          [key]: value,
        },
      };
    },
    addUser(state, payload) {
      return {
        ...state,
        users: [...state.users, payload],
      };
    },
    clearNewUser(state, payload) {
      return {
        ...state,
        newUser: {
          email: "",
          name: "",
          type: payload
            ? { value: "transporter", label: "Transportadora" }
            : { value: "transporter", label: "Gerente de Transportadora" },
          userSubType: payload ? "" : "user_admin",
          driverLicense: "",
          driverLicenseExpiration: "",
          tollNumber: "",
        },
      };
    },
    clearFormErrors(state, payload) {
      return {
        ...state,
        formErrors: {},
      };
    },
    setValidation(state, payload) {
      const { error, attr } = payload;

      return {
        ...state,
        formErrors: {
          ...state.formErrors,
          [attr]: error,
        },
      };
    },
    setLoading(state, payload) {
      return {
        ...state,
        loading: payload,
      };
    },
    clearRelation(state, payload) {
      return {
        ...state,
        permission: {
          selectedId: [],
          relatedAddresses: [],
          error: false,
        },
      };
    },
    clearSelectedUser(state, payload) {
      return {
        ...state,
        selectedUser: {},
      };
    },
    setRelation(state, payload) {
      if (payload.length) {
        const idArray = [];
        payload.filter((i) => i.accessibleToUser === true && idArray.push(i.id));
        return {
          ...state,
          permission: {
            selectedId: idArray,
            relatedAddresses: payload,
            error: false,
          },
        };
      }
      return {
        ...state,
        permission: {
          selectedId: payload,
          relatedAddresses: payload,
          error: true,
        },
      };
    },
    setSelectedId(state, payload) {
      return {
        ...state,
        permission: {
          ...state.permission,
          selectedId: payload
        }
      }
    },
    setSelectedUser(state, payload) {

      if (payload.driverLicenseExpiration) {
        const dateArray = payload.driverLicenseExpiration.split("-");
        payload.driverLicenseExpiration = dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0];
      }
      return {
        ...state,
        selectedUser: payload || {},
      };
    },
    updateSelectedUserField(state, payload) {
      const { key, value } = payload;
      return {
        ...state,
        selectedUser: {
          ...state.selectedUser,
          [key]: value,
        },
      };
    },
    toggleTransporter(state, payload) {
      return {
        ...state,
        permission: {
          ...state.permission,
          selectedId: payload,
        },
      };
    },
    setCreatedUserId(state, payload) {
      return {
        ...state,
        newUser: { ...state.newUser, id: payload },
      };
    },
    setManager(state, payload) {
      return { ...state, managerId: payload }
    }
  },
  effects: (dispatch) => ({
    async setValidationAsync(payload) {
      this.setValidation(payload);
    },
    async clearNewUserAsync(payload, rootState) {
      const transporter = rootState.auth.user.groups.includes("transporter");

      this.clearNewUser(transporter);
    },
    async setManagerAsync(payload, rootState) {
      this.setManager(payload);
    },
    async getUsersAsync(payload) {
      try {
        this.setLoading(true);
        const { types, page, searchString } = payload;
        const res = await UserClient.getAllManageable(types, page, searchString);
        this.setUsers(res.data.items);
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(handleToastError("users", "get Users: listagem de usuários"));
      }
    },
    async getSelectedUserAsync(payload) {
      try {
        this.setLoading(true);
        const res = await UserClient.getSingleUser(payload);
        this.setSelectedUser(res.data);
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(handleToastError("users", "get selected user: seleção de usuários"));
      }
    },

    async activateUserAsync(payload) {
      try {
        this.setLoading(true);
        const { toggle, userId } = payload;
        await UserClient.activateUser(toggle, userId);
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(handleToastError("users", "activate user: ativação de usuários"));
      }
    },
    async setNewUserAsync(payload) {
      try {
        this.setNewUser(payload);
      } catch (error) {
        toast.error(handleToastError("users", "set new user: definição de novo usuário"));
      }
    },
    async getTransportersAsync(payload, rootState) {
      try {
        const { userId, managerId } = payload

        if (userId && managerId) {

          const userTransporters = await UserClient.getTransportersByUser(userId);
          const managerTransporters = await UserClient.getTransportersByUser(managerId);

          const intersection = userTransporters.data.map(x =>
            !managerTransporters.data.includes(x) && x.id
          );
          dispatch.transporters.setTransporters(managerTransporters.data);
          this.setSelectedId(intersection)
        }

        if (userId && !managerId) {
          const userTransporters = await UserClient.getTransportersByUser(userId);
          const { data } = userTransporters;
          dispatch.transporters.setTransporters(data);
        }
        if (!userId && managerId) {
          const managerTransporters = await UserClient.getTransportersByUser(managerId);

          dispatch.transporters.setTransporters(managerTransporters.data);

        }
      } catch (error) {
        await toast.error("Algo deu errado na busca de transportadoras :( !", {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    },
    async toggleTransporterAsync(payload, rootState) {
      try {
        const { id } = payload;

        const idAlreadyExists = (await rootState.users.permission.selectedId.indexOf(id)) > -1;
        let copyArray = await rootState.users.permission.selectedId.slice();
        if (idAlreadyExists) {
          copyArray = await rootState.users.permission.selectedId.filter((i) => i !== id);
          this.toggleTransporter(copyArray);
        } else {
          copyArray.push(id);
          this.toggleTransporter(copyArray);
        }
      } catch (error) {
        toast.error(handleToastError("users", "set new user: definição de novo usuário"));
      }
    },
    async getRelationByAddressNumber(payload) {
      try {
        this.setLoading(true);
        const { address, idUser, type } = payload;
        const res = await TransporterClient.getRelationByAddress(address, idUser, type);
        this.setRelation(res.data);
        if (!res.data.length) {
          dispatch.dialogs.openReadingNotificationDialog({
            isOpen: true,
            subject: "Usuário sem address registrado!",
            message: "Usuário não tem acesso a nenhum address ainda. Verifique se você digitou os dados corretamente!",
            url: null,
          });
          dispatch.users.clearRelationAsync(payload);
        }
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(handleToastError("users", "get address relation: busca da relação de addresses por usuário"));
      }
    },
    async getRelationByDocumentNumberAsync(payload) {
      try {
        this.setLoading(true);
        const { cnpj, idUser, type } = payload;
        const res = await TransporterClient.getRelationByCNPJ(cnpj, idUser, type);
        this.setRelation(res.data);
        if (!res.data.length) {
          dispatch.dialogs.openReadingNotificationDialog({
            isOpen: true,
            subject: "Transportadoras não encontradas para CNPJ ou address informados.",
            message: "Verifique se os números digitados estão corretos e tente novamente ou entre em contado com o Suporte!",
            url: null,
          });
        }
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(handleToastError("users", "get CNPJ relation: busca da relação de addresses por cnpj e usuário"));
      }
    },
    async saveManagerPermissionsAsync(payload) {
      try {
        this.setLoading(true);
        const { idUser, selectedId, type } = payload;
        await UserClient.setManagerPermissions(idUser, selectedId, type);
        dispatch.dialogs.openReadingNotificationDialog({
          isOpen: true,
          subject: "Permissões salvas com sucesso!",
          message: "Novas permissões adicionadas para o usuário selecionado.",
          url: null,
        });
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(
          handleToastError("users", "saving permissions: erro ao salvar permissões de addresses para este usuário"),
        );
      }
    },
    async createTransporterAsync(payload, rootState) {
      try {

        const {
          email,
          type,
          userSubType,
          name,
          driverLicense,
          driverLicenseExpiration,
          tollNumber,
        } = rootState.users.newUser;
        this.setLoading(true);
        const nameArray = name.split(" ");
        const firstNameArray = nameArray.slice(0, 1);
        const firstName = String(firstNameArray);

        const lastNameArray = nameArray.slice(1);
        const surName = lastNameArray.join(" ");

        const newTransporter = await UserClient.createUser(
          email,
          type.value,
          firstName,
          surName,
          userSubType,
          driverLicense,
          driverLicenseExpiration,
          tollNumber,
        );

        const selectedId = rootState.users.permission.selectedId

        await UserClient.setTransporterPermissions(parseInt(newTransporter.data.id), selectedId, type.value);
        dispatch.dialogs.openReadingNotificationDialog({
          isOpen: true,
          subject: "Transportadoras associadas com sucesso!",
          message: "Novas transportadoras adicionadas para o usuário selecionado.",
          url: null,
        });
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(
          handleToastError(
            "users",
            "saving transporter's access: erro ao salvar transportadoras relacionadas a para este usuário",
          ),
        );
      }
    },
    async updateTransporterPermissionsAsync(payload) {
      try {
        this.setLoading(true);
        const { selectedId, idUser } = payload;
        await UserClient.setTransporterPermissions(idUser, selectedId);
        dispatch.dialogs.openReadingNotificationDialog({
          isOpen: true,
          subject: "Transportadoras associadas com sucesso!",
          message: "Novas transportadoras adicionadas para o usuário selecionado.",
          url: null,
        });
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        toast.error(
          handleToastError(
            "users",
            "Erro na associação de transportadoras para o usuário a ser criado., verifique se você não esqueceu de selecionar pelo menos uma opção antes de salvar.",
          ),
        );
      }
    },
    async clearRelationAsync(payload) {
      try {
        this.clearRelation();
      } catch (error) {
        toast.error(handleToastError("users", "clear relation of addresses: limpa a relação de addresses por usuário"));
      }
    },
    async updateUserAsync(payload, lastState) {
      try {
        const { contactEmail, phone, id } = { ...lastState.users.selectedUser, ...(payload ?? {}) };
        this.setLoading(true);
        const updatedUser = await UserClient.setUserData(
          id,
          contactEmail,
          phone,
        );
        this.setLoading(false);
        toast.success("Usuário atualizado com sucesso!")
        return updatedUser.data;
      } catch (error) {
        toast.error(handleToastError("users", "update user: Falha na atualização do usuário"));
      }
    },
    async createUserAsync(payload, lastState) {
      try {
        const {
          email,
          contactEmail,
          type,
          userSubType,
          name,
          driverLicense,
          driverLicenseExpiration,
          bpNumber,
          tollNumber,
          phone,
        } = { ...lastState.users.newUser, ...(payload ?? {}) };
        this.setLoading(true);
        const nameArray = name.split(" ");
        const firstNameArray = nameArray.slice(0, 1);
        const firstName = String(firstNameArray);

        const lastNameArray = nameArray.slice(1);
        const surName = lastNameArray.join(" ");

        const isSubType = ["driver", "check_in_agent"].indexOf(type.value) !== -1 ? "" : userSubType;

        const newUser = await UserClient.createUser(
          email,
          contactEmail,
          type.value,
          firstName,
          surName,
          isSubType,
          driverLicense,
          driverLicenseExpiration,
          bpNumber,
          tollNumber,
          phone
        );
        // await this.setCreatedUserId(newUser.data.id);
        await this.addUser(newUser.data.id);
        this.setLoading(false);
        return newUser.data;
      } catch (error) {
        this.setLoading(false);
        if( error?.response?.data ) {
          toast.error(error?.response?.data);
        } else {
          toast.error(handleToastError("users", "create user: criação de novo  usuário"));
        }
        return null;
      }
    },
  }),
};
